import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => (
  <div className="container-fluid page-layout dashboard-table-view">
    <div className="row">
      <div className="col-md-10 m-auto">
        <h1>Terms and Conditions</h1>
        <p>
          <i>Last update: 25th of May 2021</i>
        </p>
        <p>
          <strong>
            This page explains our terms of use. When you use the Avaldao Dapp, you’re agreeing to all
            the rules as explained in this page. We have tried to express these terms in a simple
            manner avoiding, for the most part, the complex legal jargon.
          </strong>
        </p>
        <p>
          Welcome to the beta version of the Avaldao dapp. By using this website{' '}
          <a href="https://avaldao.org">avaldao.org</a> (the “Dapp” and “Site”) offered by
          Avaldao representatives, volunteers, consultants, contributors,
          officers, and directors (collectively, “Avaldao,” “we,” or “us”), you’re agreeing to these
          legally binding rules (the “Terms”). You’re also agreeing to our{' '}
          <Link to="/privacypolicy">Privacy Policy</Link> and agreeing to follow any other rules on
          the Site, like our Community Guidelines and on boarding new projects.
        </p>
        <p>
          We may change these terms from time to time. If we do, we’ll let you know about any
          material changes, either by notifying you on the Dapp or by sending you an email. New
          versions of the terms will never apply retroactively — we’ll tell you the exact date they
          go into effect. If you keep using <a href="https://avaldao.org">avaldao.org</a>{' '}
          after a change, that means you accept the new terms.
        </p>
        <p>
          Avaldao dapp is for your personal, non-commercial use, except as explained in section 4 and
          section 5 below.
        </p>
        <h1>1. Creating an Account</h1>
        <p>
          To sign up for a Avaldao account, you need to be 18 or over. You’re responsible for your
          account and all the activity on it.
        </p>
        <p>
          You can browse Avaldao without registering for an account. But to use some of Avaldao’s functions,
          you’ll need to register either using external web3 wallet provider or the embedded Portis
          wallet (please see their Terms of Service and Privacy Policy). Only then you are able to
          fill in your profile and when you do that, the information you give us has to be accurate
          and complete. Don’t impersonate anyone else or choose names that are offensive or that
          violate anyone’s rights. If you don’t follow these rules, we may cancel your account.
        </p>
        <p>
          When you create an account on the Dapp, you are responsible for maintaining the security
          of your account and you are fully responsible for all activities that occur under the
          account. You must immediately notify{' '}
          <a href="mailto:avaldao@acdi.org.ar">avaldao@acdi.org.ar</a> of any unauthorized uses of your
          account or any other breaches of security. You’re responsible for all the activity on your
          account, and for keeping your connection method secured..
        </p>
        <p>
          Avaldao will not be liable for any acts or omissions by you, including any damages of any kind
          incurred as a result of such acts or omissions.
        </p>
        <h1>2. Things You must AVOID in general</h1>
        <p>
          This section is a list of things you probably already know you shouldn’t do — lie, break
          laws, abuse people, Impersonate someone else, steal money or data, hack other people’s
          computers, and DO NOT MESS with our system. Please behave yourself. Don’t do this stuff.
        </p>
        <p>
          We expect everyone to behave responsibly and help keep this a nice place. Don’t do any of
          these things on the Dapp:
        </p>
        <ul>
          <li>
            Don’t break the law. Don’t take any action that infringes or violates other people’s
            rights, violates the law, or breaches any contract or legal duty you have toward anyone.
          </li>
          <li>
            Don’t lie to people. Don’t post information you know is false, misleading, or
            inaccurate. Don’t do anything deceptive or fraudulent.
          </li>
          <li>
            Don’t offer prohibited items. Don’t offer any rewards that are illegal, violate any of
            Avaldao’s policies, rules, or guidelines, or violate any applicable law, statute, ordinance,
            or regulation.
          </li>
          <li>
            Don’t victimize anyone. Don’t do anything threatening, abusive, harassing, defamatory,
            libelous, tortious, obscene, profane, or invasive of another person’s privacy.
          </li>
          <li>
            Don’t spam. Don’t distribute unsolicited or unauthorized advertising or promotional
            material, or any junk mail, spam, or chain letters. Don’t run mail lists, listservs, or
            any kind of auto-responder or spam on or through the Dapp.
          </li>
          <li>
            Don’t harm anyone’s computer. Don’t distribute software viruses, or anything else (code,
            films, programs) designed to interfere with the proper function of any software,
            hardware, or equipment on the Dapp (whether it belongs to Avaldao or another party).
          </li>
          <li>
            Don’t abuse other users’ personal information. When you use Avaldao — and especially if you
            create a successful project — you may receive information about other users, including
            things like their names, email addresses, and postal addresses. This information is
            provided for the purpose of participating in a Avaldao project: don’t use it for other
            purposes, and don’t abuse it.
          </li>
        </ul>
        <h1>3. Things YOU must refrain from doing with the Dapp</h1>
        <ul>
          <li>Don’t try to interfere with the proper workings of the dapp.</li>
          <li>
            Don’t bypass any measures we’ve put in place to secure the process of traceability.
          </li>
          <li>
            Don’t try to damage or get unauthorized access to any system, data, password, or other
            information, whether it belongs to Avaldao or another party.
          </li>
          <li>
            Don’t take any action that imposes an unreasonable load on our infrastructure, or on our
            third-party providers. (We reserve the right to determine what’s reasonable.)
          </li>
          <li>
            Don’t use any kind of software or device (whether it’s manual or automated) to “crawl”
            or “spider” any part of the Site.
          </li>
          <li>
            Don’t take apart or reverse engineer any aspect of Avaldao in an effort to access things
            like source code, underlying ideas, or algorithms. Our code is open source.
          </li>
        </ul>
        <p>
          <strong>Regarding your Content: </strong>
        </p>
        <ul>
          <li>
            Your Content does not contain or install any viruses, worms, malware, Trojan horses or
            other harmful or destructive content;
          </li>
          <li>
            Your Content is not spam, is not machine-or randomly-generated, and does not contain
            unethical or unwanted commercial content designed to drive traffic to third party sites
            or boost the search engine rankings of third party sites, or to further unlawful acts
            (such as phishing) or mislead recipients as to the source of the material (such as
            spoofing);
          </li>
          <li>
            Your Content is not pornographic, does not contain threats or incite violence, and does
            not violate the privacy or publicity rights of any third party;
          </li>
          <li>
            Your content is not getting advertised via unwanted electronic messages such as spam
            links on newsgroups, email lists, blogs and websites, and similar unsolicited
            promotional methods;
          </li>
          <li>
            Your content is not named in a manner that misleads your readers into thinking that you
            are another person or company; and
          </li>
        </ul>
        <h1>4. What you should know about Projects and Campaigns</h1>
        <p>
          Most of our Terms of Use explain your relationship with Avaldao. This section is different —
          it explains the relationship between Builders, the project creators and owners, and
          Supporters (funding contributors) of Avaldao projects, and who’s responsible for what. This is
          what you’re agreeing to when you create/own or support a Avaldao project.
        </p>
        <p>
          Avaldao provides a funding vehicle for humanitarian, social and environmental impact projects
          that aim at addressing gaps and making life better for all. When a Builder posts a project
          on Avaldao, they’re inviting other people to form a contract with them. Anyone who supports a
          project is accepting the Builder’s offer, and forming that contract.
        </p>
        <p>
          <strong>Avaldao is not a part of this contract</strong> — the contract is a direct legal
          agreement between project creators and their supporters. Here are the terms that govern
          that agreement:
        </p>
        <p>
          When a project is successfully funded, the Builder must complete the milestones to fulfill
          the conditions and get rewarded. Once a Builder has done so, a designated reviewer (in
          some cases Avaldao reserves the right to be the reviewer) will check how the conditions were
          satisfied.
        </p>
        <p>
          Throughout the process, Builders owe their Supporters a high standard of effort, honest
          communication, and a dedication to bringing the project to life. At the same time,
          supporters must understand that when they support a project, they’re helping to create
          something special, altruistic and that their contribution is only part of the holistic
          effort that involves executing the project.
        </p>
        <p>
          There may be changes or delays, and there’s a chance something could happen that prevents
          the Builder from being able to finish the project as promised.
        </p>
        <p>
          If a Builder is unable to complete their project and fulfill the milestones, they’ve
          failed to live up to the basic obligations of this agreement. To right this, they must
          make every reasonable effort to find another way of bringing the project to the best
          possible conclusion for supporters. A Builder in this position has only remedied the
          situation and met their obligations to supporters, if:
        </p>
        <ul>
          <li>
            they post an update that explains what work has been done, how funds were used, and what
            prevents them from finishing the project as planned;
          </li>
          <li>
            they work diligently and in good faith to bring the project to the best possible
            conclusion in a timeframe that’s communicated to supporters;
          </li>
          <li>
            they’re able to demonstrate that they’ve used funds appropriately and made every
            reasonable effort to complete the project as promised;
          </li>
          <li>
            they’ve been honest, and have made no material misrepresentations in their communication
            to supporters; and
          </li>
          <li>
            they offer to return any remaining funds to supporters who have not received their
            reward (in proportion to the amounts pledged), or else explain how those funds will be
            used to complete the project in some alternate form.
          </li>
        </ul>
        <p>
          The Builder is solely responsible for fulfilling the promises made in their project. If
          they’re unable to satisfy the terms of this agreement, they may be subject to legal action
          by the community.
        </p>
        <h1>5. Funds Management</h1>
        <p>
          This section goes over the details of supporting and creating projects — things like how
          money gets collected, whether pledges can be changed or canceled, and how Builders can
          contact supporters to provide updates and how Avaldao makes use of donated funds.
        </p>
        <p>These are the terms that apply when you’re supporting a project:</p>
        <ul>
          <li>
            Your donation will be released to the Builder only if milestones are approved. You’ll
            provide your contribution information when you pledge, we will not accept contributions
            larger than 10K USD. Your donation will only be collected if, at the time of the
            project’s funding timelines, the project has reached its milestones goal. The exact
            amount you donated is the amount sent to the smart contracts and the amount that will be
            collected. If the milestones are not reached and canceled, the donation will be returned
            to the donors or the entities who delegated the donation to the milestone.
          </li>
          <li>
            We do not take credit cards or bank transfers, all donations are made in whitelisted
            cryptocurrencies (currently RBTC).
          </li>
          <li>
            You can not change or cancel your pledge (with one exception). As we are using on chain
            transactions, it is difficult to make changes to your contribution. If you donated to
            Campaign or Milestone, you will only be refunded if they are canceled. If you donated to
            a Fund you are able to withdraw your donation at any time.
          </li>
          <li>
            <strong>
              Avaldao is not responsible for the donations given to the projects and has no access to
              the funds.
            </strong>{' '}
            Responsibility for finishing a project lies entirely with the Builder. Avaldao doesn’t hold
            funds on Builders’ behalf, cannot guarantee Builder’s work, and does not offer refunds.
          </li>
          <li>
            Avaldao offers total transparency in the use of funds allocated to support selected
            projects. Avaldao does not guarantee funds will follow the intended process, contributors
            may donate funds at their own discretion.
          </li>
        </ul>
        <h3>Funds donated directly to the Avaldao Program Fund</h3>
        <p>
          This section explains how the Avaldao organization is also a user of the dapp to provide full
          transparency in the way funds from donations are being allocated through its program. The
          Avaldao Catalyzing Program Identifies, help Build and Implement Global Impact projects:
        </p>
        <ul>
          <li>
            <strong>The Avaldao Program Fund and Campaign</strong> are one of the users of the Avaldao dapp
            as a Builder.
          </li>
          <li>
            Donors have visibility as to where their donation has been assigned similarly to any
            other projects on the platform.
          </li>
          <li>Additionally, if requested Avaldao can provide a donation receipt to Contributors.</li>
          <li>
            The funds pledged to the Program Fund are managed by the Builder (the Avaldao core team
            wallet) and assigned to actions/milestones of the selected projects in the Avaldao Program.
          </li>
          <li>
            The projects milestones are specific actions that will be completed to advance the
            development of the projects in accordance to a roadmap.
          </li>
          <li>
            The funds allocated to milestones will cover the costs of resources assigned to provide
            business, technical and legal support to projects.
          </li>
          <li>Funds may be used to cover contractors or contributors incentives.</li>
          <li>
            Funded project milestones can be collected only when both project and Avaldao team have
            jointly completed the tasks.
          </li>
          <li>
            Milestone Reviewers may be comprised of project team members under the program, Avaldao core
            team, mentors, board members and advisors.
          </li>
        </ul>
        <h3>Information you need to know if you are a Builder and who is managing a project</h3>
        <p>These are the terms that apply when you’re creating a project:</p>
        <ul>
          <li>
            You can refund individual pledges if you want. After your project has been funded, you
            can cancel and refund a supporter’s pledge at any time. If you do, you have no further
            obligation to that specific supporter, and no agreement exists between you.
          </li>
          <li>
            We’ll charge our transaction fees after putting funds in your account. Avaldao and its
            partners may subtract fees before or after transmitting the proceeds of a campaign.
          </li>
          <li>
            We cannot help resolve payment disputes. If a supporter of your project disputes the
            donation. You’ll be notified that a dispute has been filed, and you’ll be able to
            provide evidence to help us resolve it in your favor.
          </li>
          <li>
            Don’t count your chickens before they hatch. Don’t assume you’ll be able to launch your
            project when you want; there could be a reason we’re not able to accept it, or a problem
            that takes time to resolve. Don’t assume you’ll be able to immediately collect your
            funding; there may be a delay between the end of a successful campaign and your access
            to the funds. And don’t take any actions in reliance on collecting any of the money
            pledged until you actually have the ability to withdraw it from your account and spend
            it.
          </li>
        </ul>
        <h1>6. Stuff We Don’t Do and Are Not Responsible For</h1>
        <p>
          Avaldao isn’t liable for any damages or losses related to your use of the dapp. We don’t
          become involved in disputes between users, or between users and any third party relating
          to the use of the services. We don’t oversee the performance or punctuality of projects,
          (unless they are projects supported by Avaldao programs) and we don’t endorse any content
          users submit to the Site. When you use the Dapp, you release Avaldao from claims, damages, and
          demands of every kind — known or unknown, suspected or unsuspected, disclosed or
          undisclosed — arising out of or in any way related to such disputes or use of the dapp.
          All content you access through the dapp is at your own risk. You’re solely responsible for
          any resulting damage or loss to any party.
        </p>
        <h1>7. Other Websites</h1>
        <p>
          If you follow a link to another website, what happens there is between you and them — not
          us.
        </p>
        <p>
          Avaldao Sites and dapp may contain links to other websites (for instance, project pages, user
          profiles, and comments may link to other sites.) When you access third-party websites, you
          do so at your own risk. We don’t control or endorse those sites.
        </p>
        <p>
          Avaldao may partner with other companies for payment processing. When you support or create a
          project, you’re also agreeing to the payment processor’s terms of service.
        </p>
        <h1>8. Your Intellectual Property</h1>
        <p>
          We don’t own the stuff you post on Avaldao dapp. But when you post it, you’re giving us
          permission to use or copy it however we need in order to run the site, or show people
          what’s happening on it (we generally just use this to promote projects and showcase our
          community on the website). Avaldao doesn’t own content you submit to us (your “Content”). But
          we do need certain licenses from you in order for the site to perform. When you submit a
          project for review, or launch a project, you agree to these terms:
        </p>
        <ul>
          <li>
            We can use the content you’ve submitted. You grant to us, and others acting on our
            behalf, the worldwide, non-exclusive, perpetual, irrevocable, royalty-free,
            sublicensable, transferable right to use, exercise, commercialize, and exploit the
            copyright, publicity, trademark, and database rights with respect to your Content.
          </li>
          <li>
            When we use the content, we can make changes, like editing or translating it. You grant
            us the right to edit, modify, reformat, excerpt, delete, or translate any of your
            Content.
          </li>
          <li>
            You won’t submit stuff you don’t hold the copyright for (unless you have permission).
            Your Content will not contain third-party copyrighted material, or material that is
            subject to other third-party proprietary rights, unless you have permission from the
            rightful owner of the material, or you are otherwise legally entitled to post the
            material (and to grant Avaldao all the license rights outlined here).
          </li>
          <li>
            Any royalties or licensing on your Content are your responsibility. You will pay all
            royalties and other amounts owed to any person or entity based on your Content, or on
            Avaldao’s hosting of that Content.
          </li>
          <li>
            You promise that if we use your Content, we’re not violating anyone’s rights or
            copyrights. If Avaldao or its users exploit or make use of your submission in the ways
            contemplated in this agreement, you promise that this will not infringe or violate the
            rights of any third party, including (without limitation) any privacy rights, publicity
            rights, copyrights, contract rights, or any other intellectual property or proprietary
            rights.
          </li>
          <li>
            You’re responsible for the stuff you post. All information submitted to the Site,
            whether publicly posted or privately transmitted, is the sole responsibility of the
            person from whom that content originated.
          </li>
          <li>
            We’re not responsible for mistakes in your content. Avaldao will not be liable for any
            errors or omissions in any content.
          </li>
        </ul>
        <h1>9. Avaldao’s Intellectual Property</h1>
        <p>
          The content on the dapp is not protected. You do have the right to use it for certain
          personal purposes, but you can’t use it for anything commercial without getting permission
          first.
        </p>
        <p>
          <u><a target="_blank" href="https://github.com/ACDI-Argentina/efem-crowdfunding-dapp">
          Avaldao’s Site and Dapp are open source</a></u>. However, you agree to respect the work and legal
          notices, information, and restrictions contained in any content accessed through the Site.
          You also agree not to change, translate, or otherwise create derivative works of the Site
          or Dapp, unless you were given consent.
        </p>
        <p>
          Avaldao grants you access to reproduce content from the Site/Dapp for personal use only. This
          access covers both Avaldao’s own protected content and user-generated content on the Site
          (this license is worldwide, non-exclusive, non-sublicensable, and non-transferable). If
          you want to use, reproduce, modify, distribute, or store any of this content for a
          commercial purpose, you need prior written permission from the relevant copyright holder.
          A “commercial purpose” means you intend to use, sell, license, rent, or otherwise exploit
          content for commercial use, in any way.
        </p>
        <h1>10. How We Deal with Copyright Issues</h1>
        <p>
          We comply with the Digital Millennium Copyright Act. To learn more about how we deal with
          claims of copyright infringement, read our Copyright Policy.
        </p>
        <p>
          We reserve the right to delete or disable content alleged to be infringing, and to
          terminate accounts for repeat infringers (we do this when appropriate and at our sole
          discretion.)
        </p>
        <h1>11. Deleting Your Account</h1>
        <p>
          You may request to delete your account at any time. Deleting your account won’t
          automatically make some content you’ve already posted go away as this content may reside
          on an on-chain network where it cannot be deleted.
        </p>
        <p>
          All provisions of this agreement survive termination of an account, including our rights
          regarding any content you’ve already submitted to the Site/Dapp. (For instance, if you’ve
          launched a project, deleting your account will not automatically remove the project from
          the Site.) You can contact us at <a href="mailto:avaldao@acdi.org.ar">avaldao@acdi.org.ar</a>{' '}
          for additional information or to request project page deletion (this is not available in
          all circumstances).
        </p>
        <h1>12. Our Rights</h1>
        <p>
          To comply and keep things running smoothly, we need to be able to maintain control over
          what happens on our website. So in this section, we reserve the right to make decisions to
          protect the health and integrity of our system. We don’t take these powers lightly, and we
          only use them when we absolutely have to.
        </p>
        <p>Avaldao reserves these rights:</p>
        <ul>
          <li>
            We can make changes to the Dapp Site and functionalities without notice or liability.
          </li>
          <li>
            We have the right to decide who’s eligible to use the Dapp. We can cancel accounts or
            decline to offer access. (Especially if you’re abusing them.) We can change our
            eligibility criteria at any time. If these things are prohibited by law where you live,
            then we revoke your right to use the Avaldao dapp in that jurisdiction.
          </li>
          <li>
            We have the right to reject, cancel, interrupt, remove, or suspend any project at any
            time and for any reason.
          </li>
        </ul>
        <strong>
          Avaldao is not liable for any damages as a result of any of these actions, and it is our
          policy not to comment on the reasons for any such action.
        </strong>
        <h1>13. Warranty Disclaimer</h1>
        <p>
          We work in good faith and try our best efforts to maintain a compliant, efficient and
          transparent environment, but we can’t guarantee everything will always work perfectly.
          This site is presented as-is, without warranties.{' '}
          <strong>
            You use our Site and Dapp versions solely at your own risk. They are provided to you “as
            is” and “as available” and without warranty of any kind, express or implied.
          </strong>
        </p>
        <p>Here is the version with the legal jargon: </p>
        <p>
          Avaldao SPECIFICALLY DISCLAIMS ANY AND ALL WARRANTIES AND CONDITIONS OF MERCHANTABILITY,
          NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY
          COURSE OF DEALING, COURSE OF PERFORMANCE, OR USAGE OF TRADE. NO ADVICE OR INFORMATION
          (ORAL OR WRITTEN) OBTAINED BY YOU FROM Avaldao SHALL CREATE ANY WARRANTY.
        </p>
        <h1>14. Indemnification</h1>
        <p>If you do something on Avaldao that winds up getting us sued, you have to help defend us.</p>
        <p>
          If you do something that gets us sued, or break any of the promises you make in this
          agreement, you agree to defend, indemnify, and hold us harmless from all liabilities,
          claims, and expenses (including reasonable attorneys’ fees and other legal costs) that
          arise from or relate to your use or misuse of Avaldao Site and Dapp. We reserve the right to
          assume the exclusive defense and control of any matter otherwise subject to this
          indemnification clause, in which case you agree that you’ll cooperate and help us in
          asserting any defenses.
        </p>
        <h1>15. Limitation of Liability</h1>
        <p>If something bad happens as a result of your using the Site/Dapp, we’re not liable.</p>
        <p>
          To the fullest extent permitted by law, in no event will Avaldao, its directors, employees,
          partners, suppliers, contributors, mentors, advisors or content providers be liable for
          any indirect, incidental, punitive, consequential, special, or exemplary damages of any
          kind, including but not limited to damages (i) resulting from your access to, use of, or
          inability to access or use the dapp; (ii) for any lost profits, data loss, or cost of
          procurement or substitute goods or services; or (iii) for any conduct of content of any
          third party on the Site. In no event shall Avaldao’s liability for direct damages be in excess
          of (in the aggregate) one hundred EURO (EUR100.00).
        </p>
        <h1>16. The Rest</h1>
        <p>
          These are our official terms and our rules for how things work. (So if you ever see
          confusing or conflicting information about any of this stuff, just check these terms —
          they’re the last word.) Thanks so much for reading them, we know how painful it can be.
        </p>
        <p>
          These Terms and the other material referenced in them are the entire agreement between you
          and Avaldao with respect to the Dapp. They supersede all other communications and proposals
          (whether oral, written, or electronic) between you and Avaldao with respect to the Dapp and
          govern our future relationship. If any provision of these Terms is found to be invalid
          under the law, that provision will be limited or eliminated to the minimum extent
          necessary so that the Terms otherwise will remain in full force and effect and
          enforceable. The failure of either you or Avaldao to exercise any right provided for in these
          Terms in any way won’t be deemed a waiver of any other rights.
        </p>
        <p>
          These Terms are personal to you. You can’t assign them, transfer them, or sublicense them
          unless you get Avaldao’s prior written consent. Avaldao has the right to assign, transfer, or
          delegate any of its rights and obligations under these Terms without your consent. Avaldao
          will provide you notice via email, written notice, or by conspicuously posting the notice
          on our Dapp.
        </p>
      </div>
    </div>
  </div>
);

export default TermsAndConditions;
